import { useEffect } from "react";
import { intercomService } from "../../services/IntercomService";

export function GuestIntercomMessenger() {
  const appId = process.env.REACT_APP_INTERCOM_APP_ID;

  useEffect(() => {
    if (!appId) {
      return undefined;
    }

    intercomService.boot({
      app_id: appId,
      vertical_padding: 80,
    });

    return () => {
      intercomService.shutdown();
    };
  }, [appId]);

  return null;
}
